import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { ModeratorIcon } from '../../components/icons';
import Modal from '../../components/modal';
import Confirmation from '../../components/confirmation';
import PromoteUserDetails from '../promote-user-details';
import { HorizontalSeparator, VerticalSeparator } from '../../components/separator';
import withDeviceType from '../../hoc/with-device-type';
import withTranslate from '../../hoc/with-translate';
import styles from './demote-moderator-modal.scss';

export const DemoteModeratorModal = ({ user, closeModal, demoteModerator, isDesktop, isMobile, t }) =>
  <Modal className={styles.modal} onClose={closeModal}>
    <div className={styles.container}>
      <PromoteUserDetails user={user}/>
      {isMobile && <HorizontalSeparator className={styles.horizontalSeparator}/>}
      {isDesktop && <VerticalSeparator className={styles.verticalSeparator}/>}
      <Confirmation
        icon={ModeratorIcon}
        title={t('demote-moderator-modal.remove-moderator-permissions')}
        confirm={t('demote-moderator-modal.confirm')}
        onConfirm={demoteModerator}
        cancel={t('demote-moderator-modal.cancel')}
        onCancel={closeModal}
      >
        <p>
          {t('demote-moderator-modal.are-you-sure')}
        </p>
        <p>
          {t('demote-moderator-modal.will-no-longer')}
        </p>
        <ul>
          <li>
            {t('demote-moderator-modal.delete-posts')}
          </li>
          <li>
            {t('demote-moderator-modal.disable-commenting')}
          </li>
          <li>
            {t('demote-moderator-modal.move-posts')}
          </li>
        </ul>
      </Confirmation>
    </div>
  </Modal>;

DemoteModeratorModal.propTypes = {
  user: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  demoteModerator: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool,
  isMobile: PropTypes.bool,
  t: PropTypes.func,
};

export default _.flowRight(withDeviceType, withTranslate)(DemoteModeratorModal);



// WEBPACK FOOTER //
// ./app/components/demote-moderator-modal/demote-moderator-modal.js